import { Box, Grid, Typography, styled, useTheme } from "@mui/material";

import CardSkeleton from "components/Skeletons/Card.Skeleton";
import { DefaultUrlWeb } from "config/Configuration";
import FancyCard from "components/FancyCard";
import NumberFormats from "components/NumberFormats";
import PortfolioChart from "./PortfolioChart";
import { useSelector } from "react-redux";

function PortfolioChartDebit() {
  const theme = useTheme();

  const portfolioChart = useSelector(
    (state) => state.portfolio.portfolioChart?.data
  );

  return (
    <>
      {portfolioChart?.debitDetail?.length > 0 && (
        <>
          {portfolioChart?.debitDetail ? (
            <FancyCard mt={1} color={theme.palette.background.red}>
              <Grid container>
                {/* <BoxDate>
        <Typography component="small">
          123 <br /> 123
        </Typography>
      </BoxDate> */}

                <Grid item xs={12} md={6}>
                  <Typography sx={{ mb: 3 }} variant="h4" color="text.main">
                    Margin Debit
                  </Typography>

                  <Typography
                    sx={{ mb: 2 }}
                    variant="h5"
                    fontWeight={400}
                    color="text.main"
                  >
                    Total Value Debit:
                  </Typography>

                  <BoxCoin>
                    <img
                      src={DefaultUrlWeb + `/images/coin/usdt.png`}
                      alt="USDT"
                    />
                    <Typography
                      variant="h3"
                      color="common.white"
                      fontWeight={400}
                    >
                      <NumberFormats
                        value={portfolioChart?.debitCostMarketUSDT}
                      />
                      <Typography component="small" fontWeight={300}>
                        USDT
                      </Typography>
                    </Typography>
                  </BoxCoin>

                  <BoxCoin>
                    <img
                      src={DefaultUrlWeb + `/images/coin/toman.png`}
                      alt="USDT"
                    />
                    <Typography
                      variant="h3"
                      color="common.white"
                      fontWeight={400}
                    >
                      <NumberFormats
                        value={portfolioChart?.debitCostMarketToman}
                      />
                      <Typography component="small" fontWeight={300}>
                        TOMAN
                      </Typography>
                    </Typography>
                  </BoxCoin>
                </Grid>

                <Grid item xs={12} md={6}>
                  <PortfolioChart
                    portfolioChart={portfolioChart?.debitDetail}
                  />
                </Grid>
              </Grid>
            </FancyCard>
          ) : (
            <CardSkeleton heightSize={188} />
          )}
        </>
      )}
    </>
  );
}

const BoxCoin = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(1.3),
  img: {
    width: "25px",
    marginRight: theme.spacing(1),
  },
  small: {
    fontSize: "12px",
    marginLeft: theme.spacing(0.7),
  },
}));

// const BoxDate = styled(Box)(({ theme }) => ({
//   position: "absolute",
//   top: "20px",
//   right: "20px",
//   color: `${theme.palette.text.main}90`,
//   fontWeight: "300",
//   fontSize: "12px",
//   lineHeight: "18px",
//   textAlign: "right",
//   small: {
//     color: `${theme.palette.text.main}90`,
//     fontWeight: "300",
//     fontSize: "12px",
//     lineHeight: "18px",
//     textAlign: "end",
//   },
// }));

export default PortfolioChartDebit;
